import i18n from '@/i18n';
import League from './League';
import Audit from './Audit'; //$IMPORT$

export default () => [
  {
    resourceName: i18n.t('driver-index-1992f2b760694416d-1'),
    routerUrl: '/driver',
    resourceIcon: '',
    type: '0',
    buttons: [],
    children: [
      League(),
      Audit(), //$MORE$
    ],
  },
];
